var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.945h-1.055V6.328h-3.2v10.617h-1.054v-6.4H9.527v6.4H8.473V8.437H5.309v8.508H4.254v-5.344h-3.2v5.344H0V18h18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.219V0h-4.253v1.055H16.2L11.11 6.11 6.891 1.891.16 8.592l.746.746 5.99-5.955L11.11 7.6l5.836-5.8v2.419z"
  }))));
}
export default __webpack_public_path__ + "media/icons/icn_performance-41b6615b.svg";
export { SvgIcnPerformance as ReactComponent };